export default __webpack_public_path__ + "public/images/ic-packing.svg";